import { useState } from 'react'
import {
  Box,
  Button,
  Image,
  Modal,
  ModalBody,
  Stack,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import { ImagesPng } from 'assets/images'
import { motion } from 'framer-motion'
import { CloseIconTransparent } from 'assets/icons'
import {
  BtnStack,
  BtnStyled,
  ModalContentStyled,
  TextBody,
  TextHeader,
  TextHeader2,
  TextStack
} from './styled'

const MotionBox = motion(Box)

export const AskToSignUpModal = ({
  dynamicOpenModal,
  posts,
  eventData,
  type,
  setAskToSignUp,
  setOutAnim,
  outAnim
}) => {
  const [copiedToClipboard, setCopiedToClipboard] = useState(false)
  const { onOpen, isOpen, onClose } = useDisclosure()

  const handleShareBtnText = () => {
    if (type === 'blogs') {
      return 'Share Article'
    }

    if (type === 'events') {
      return 'Share Event'
    }

    return 'Share'
  }

  const handleSuccessCopyText = () => {
    if (type === 'blogs') {
      return 'Article link copied to clipboard.'
    }

    if (type === 'events') {
      return 'Event link copied to clipboard.'
    }

    return 'Link copied to clipboard.'
  }

  return (
    <Modal
      isCentered
      isOpen={dynamicOpenModal}
      trapFocus={false}
      onClose={onClose}
      bg={COLORS.whiteBlackGradientTopToBot}
      motionPreset="none"
    >
      <ModalContentStyled
        animate={{ ...(outAnim ? { scale: 0.95, opacity: 0 } : {}) }}
        transition={{
          duration: 0.1,
          ease: [0.4, 0, 1, 1]
        }}
        onAnimationComplete={() => {
          setOutAnim(false)
          setAskToSignUp(false)
        }}
        containerProps={{ zIndex: 1410 }}
      >
        <Button
          backgroundColor="transparent"
          zIndex="30"
          borderRadius="full"
          position="absolute"
          right="6px"
          top="6px"
          width="20px"
          height="20px"
          padding="0"
          minWidth="0"
          boxShadow="0 4px 10px rgba(0, 0, 0, 0.2)"
          onClick={() => setOutAnim(true)}
          filter="drop-shadow(0 2px 4px rgba(0,0,0,0.6))"
        >
          <CloseIconTransparent fill={COLORS.gold} />
        </Button>

        <ModalBody
          margin="0"
          padding="0 10px"
          textAlign="center"
          overflow="hidden"
          maxHeight="auto"
          overflowY="scroll"
          sx={{
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none'
            }
          }}
        >
          <MotionBox
            initial={{ scaleY: copiedToClipboard ? 1 : 0 }}
            animate={{
              scaleY: copiedToClipboard ? 0 : 1,
              ...(copiedToClipboard && { height: 0 })
            }}
            transition={{
              type: 'tween',
              duration: 0.5
            }}
            height="auto"
            margin={copiedToClipboard ? 0 : '10px 0'}
          >
            <Stack gap="0 !important">
              <TextHeader>You are wanted here.</TextHeader>
              <TextHeader lineHeight="30px">Please join our community.</TextHeader>
            </Stack>
          </MotionBox>

          <Stack
            alignItems="center"
            marginTop="10px"
          >
            <Image
              src={ImagesPng.Logo}
              alignItems="center"
              w={16}
              h={16}
            />
          </Stack>

          <MotionBox
            display={copiedToClipboard ? 'auto' : 'none'}
            height={copiedToClipboard ? '' : 0}
            opacity={copiedToClipboard ? 1 : 0}
            position="relative"
          >
            <TextStack>
              <TextHeader2>{ handleSuccessCopyText() }</TextHeader2>
              <TextHeader2>Thanks for sharing!</TextHeader2>
            </TextStack>
          </MotionBox>

          <MotionBox
            initial={{
              scaleY: copiedToClipboard ? 1 : 0,
              height: copiedToClipboard ? '' : 0
            }}
            animate={{
              scaleY: copiedToClipboard ? 0 : 1,
              height: copiedToClipboard ? 0 : ''
            }}
            transition={{
              type: 'tween',
              duration: 0.5
            }}
            margin={copiedToClipboard ? 0 : '10px 0 20px 0'}
          >
            <TextStack>
              <TextBody>On Connector you can find</TextBody>
              <TextBody>friends, dates, professional opportunities,</TextBody>
              <TextBody>and even events.</TextBody>
            </TextStack>

            <TextStack>
              <TextBody>It all takes place on a map,</TextBody>
              <TextBody>because real life happens</TextBody>
              <TextBody>in real world.</TextBody>
            </TextStack>

            <TextStack>
              <TextBody>Create your new network of people</TextBody>
              <TextBody>who share your hobbies, values, and goals</TextBody>
              <TextBody>with searchable keywords called affinities.</TextBody>
            </TextStack>

            <TextStack>
              <TextBody>Receive Connector Coin monthly</TextBody>
              <TextBody>in revenue sharing pools</TextBody>
              <TextBody>just for being an active member.</TextBody>
            </TextStack>

            <BtnStack margin="20px auto 10px auto">
              <BtnStyled
                animate={{
                  scale: [1, 1.05, 1],
                  opacity: [1, 0.8, 1]
                }}
                transition={{
                  repeat: Infinity,
                  duration: 1,
                  delay: 0.6
                }}
                onClick={() => document.querySelector('.profile-icon').click()}
              >
                <Text>Get Connected</Text>
              </BtnStyled>
            </BtnStack>

            <BtnStack margin="10px auto 0px auto">
              <BtnStyled
                as="button"
                onClick={() => {
                  setCopiedToClipboard(true)

                  const appUrl = process.env.REACT_APP_FRONTEND_URL
                  if (type === 'blogs') {
                    navigator.clipboard.writeText(appUrl + '/?post-id=' + posts[0]?.id)
                  } else if (type === 'events') {
                    navigator.clipboard.writeText(appUrl + '/?eventid=' + eventData?.id)
                  }

                  setTimeout(() => setCopiedToClipboard(false), 3000)
                }}
              >
                { handleShareBtnText() }
              </BtnStyled>
            </BtnStack>
          </MotionBox>
        </ModalBody>
      </ModalContentStyled>
    </Modal>
  )
}
